import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WidgetHeader from '../Widget/WidgetHeader';
import AnswerButton from '../../components/Assessment/AnswerButton';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import ShareDrawer from '../../components/ShareDrawer';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';

import { onGoToStep } from './actions';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import { Content, Footer, Title } from '../DefaultStyles/Shared';
import { Container, Body } from '../DefaultStyles/Details';

const VoteRegistrationStep3 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={24}
    >
        <Container>
            <Overlay />
            <OverlayPublisher />
            <Body>
                <WidgetHeader />
                <Content>
                    <Title
                        dangerouslySetInnerHTML={{
                            __html: props.title
                        }}
                    />
                </Content>
                <AutoScalingButtonSet mobileStyled={true}>
                    <AnswerButton
                        text={props.buttonText1}
                        useLoadingSpinner={true}
                        key="0"
                        onClick={() => {
                            props.onGoToStep(
                                'success',
                                'forward',
                                props.apiRequestData,
                                props.answerId,
                                [],
                                props.formData,
                                props.actionIdentifier,
                                props.isMultiActionsCard,
                                props.actionCompletedTime()
                            );
                            window.open(props.registrationUrl, '_blank');
                        }}
                    />
                    <AnswerButton
                        text={props.buttonText2}
                        useLoadingSpinner={false}
                        key="1"
                        onClick={() => {
                            props.onGoToStep(4, 'forward');
                        }}
                    />
                </AutoScalingButtonSet>
                <Footer>
                    <ShareDrawer rightAlign backgroundColor={'#fff'} />
                </Footer>
            </Body>
        </Container>
    </TransitionContainer>
);

VoteRegistrationStep3.propTypes = {
    title: PropTypes.string,
    buttonText1: PropTypes.string,
    buttonText2: PropTypes.string,
    onGoToStep: PropTypes.func,
    apiRequestData: PropTypes.object.isRequired,
    answerId: PropTypes.number,
    formData: PropTypes.object,
    registrationUrl: PropTypes.string,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    actionIdentifier: PropTypes.string.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    actionCompletedTime: PropTypes.func.isRequired
};

export default connect(
    state => ({
        title:
            "You are eligible to register to vote online through your state's website.",
        buttonText1: 'Register Online with ' + state.localRep.localRepData.state,
        buttonText2: 'Continue with Mail Registration',
        apiRequestData: state.widget.apiRequestData,
        answerId:
            state.voteRegistration.completeVoteRegistration.voteRegistrationAnswerId,
        formData: state.voteRegistration.formData,
        registrationUrl: state.voteRegistration.completeVoteRegistration.registrationUrl,
        isSubmitting: state.voteRegistration.isSubmitting,
        isBackTransition: state.voteRegistration.isBackTransition,
        actionIdentifier: state.widget.activeAction.identifier,
        isMultiActionsCard:
            state.widget.cards[state.widget.activeAction.order - 1].type ===
            CardTypes.multipleActions,
        actionCompletedTime: getActionCompletedTime(state, 'voteRegistration')
    }),
    { onGoToStep }
)(VoteRegistrationStep3);



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistrationStep3.jsx